import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { CheckCircle2, Lightbulb } from 'lucide-react';
export function BenefitsSection() {
  const mainBenefits = ['Aprender paso a paso técnicas de manicura desde cero, incluso si nunca lo hiciste antes.', 'Sentirte segura y confiada para hacer tus primeras uñas en casa.', 'Empezar a generar ingresos ofreciendo tus servicios de manera sencilla.', 'Organizar tu espacio y materiales para trabajar de forma práctica y eficiente.', 'Tener confianza para ofrecer servicios de calidad y fidelizar clientes'];
  const discoveries = ['Trucos para promocionarte fácilmente en redes sociales', 'Cómo fijar precios y presupuestos profesionales', 'Estrategias para crecer tu negocio desde casa', 'Materiales y herramientas esenciales para empezar sin gastar de más'];
  return <section className="py-24 bg-white" data-id="element-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <motion.span className="text-rose-600 font-bold tracking-wider uppercase text-sm mb-4 block" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-27">
            Beneficios Principales
          </motion.span>
          <SectionHeading title="Todo lo que vas a lograr" data-id="element-28" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-29">
          {/* Main Benefits */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-30">
            <div className="bg-rose-50 rounded-3xl p-8 md:p-10 h-full border border-rose-100 shadow-soft" data-id="element-31">
              <h3 className="text-2xl font-playfair font-bold mb-8 text-rose-900 border-b border-rose-200 pb-4" data-id="element-32">
                Con este producto vas a poder:
              </h3>
              <ul className="space-y-6" data-id="element-33">
                {mainBenefits.map((benefit, index) => <motion.li key={index} className="flex items-start gap-4" initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} data-id="element-34">
                    <CheckCircle2 className="w-6 h-6 text-rose-500 shrink-0 mt-1" data-id="element-35" />
                    <span className="text-dark-light text-lg" data-id="element-36">{benefit}</span>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>

          {/* Discoveries */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-37">
            <div className="bg-gold-50 rounded-3xl p-8 md:p-10 h-full border border-gold-100 shadow-soft" data-id="element-38">
              <h3 className="text-2xl font-playfair font-bold mb-8 text-gold-900 border-b border-gold-200 pb-4 flex items-center gap-3" data-id="element-39">
                <Lightbulb className="w-6 h-6 text-gold-500" data-id="element-40" />
                También vas a descubrir:
              </h3>
              <ul className="space-y-6" data-id="element-41">
                {discoveries.map((item, index) => <motion.li key={index} className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm" initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1 + 0.2
              }} data-id="element-42">
                    <div className="w-2 h-2 rounded-full bg-gold-400 mt-2.5 shrink-0" data-id="element-43"></div>
                    <span className="text-dark font-medium" data-id="element-44">{item}</span>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}